const Data = [
        {
            name: "Devaki Nandana Kalam",
            position: "Chief Executive Officer Prayas",
            imageUrl: "/assets/images/members/Devaki Nandana Kalam.jpg",
            facebookLink: "https://www.facebook.com/gyws.iitkgp",
            linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
            email: "gywsociety@gmail.com"
        },
        {
            name: "Saurav Kumar Nishant",
            position: "Chief Advisory, Prayas",
            imageUrl: "/assets/images/members/Heads21/Saurav Kumar Nishant.jpg",
            facebookLink: "https://www.facebook.com/gyws.iitkgp",
            linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
            email: "gywsociety@gmail.com"
        },
        {
            name: "Yash Raj Gupta",
            position: "Chief Advisory, Prayas",
            imageUrl: "/assets/images/members/Heads21/Yash Raj Gupta.jpg",
            facebookLink: "https://www.facebook.com/gyws.iitkgp",
            linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
            email: "gywsociety@gmail.com"
        },
    
]

export default Data;